module.exports = __webpack_public_path__ + "media/images/covers/discover-your-future/discover-logo-1-c9b24b1fb466fea2868d7fb5f5bf0c5e.png";